/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StatisticsSummaryWalletData model module.
 * @module model/StatisticsSummaryWalletData
 * @version 1.0
 */
class StatisticsSummaryWalletData {
    /**
     * Constructs a new <code>StatisticsSummaryWalletData</code>.
     * @alias module:model/StatisticsSummaryWalletData
     */
    constructor() { 
        
        StatisticsSummaryWalletData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StatisticsSummaryWalletData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StatisticsSummaryWalletData} obj Optional instance to populate.
     * @return {module:model/StatisticsSummaryWalletData} The populated <code>StatisticsSummaryWalletData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StatisticsSummaryWalletData();

            if (data.hasOwnProperty('totalHvh')) {
                obj['totalHvh'] = ApiClient.convertToType(data['totalHvh'], 'Number');
            }
            if (data.hasOwnProperty('totalPer')) {
                obj['totalPer'] = ApiClient.convertToType(data['totalPer'], 'Number');
            }
            if (data.hasOwnProperty('totalXper')) {
                obj['totalXper'] = ApiClient.convertToType(data['totalXper'], 'Number');
            }
            if (data.hasOwnProperty('totalUsdt')) {
                obj['totalUsdt'] = ApiClient.convertToType(data['totalUsdt'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>StatisticsSummaryWalletData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StatisticsSummaryWalletData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} totalHvh
 */
StatisticsSummaryWalletData.prototype['totalHvh'] = undefined;

/**
 * @member {Number} totalPer
 */
StatisticsSummaryWalletData.prototype['totalPer'] = undefined;

/**
 * @member {Number} totalXper
 */
StatisticsSummaryWalletData.prototype['totalXper'] = undefined;

/**
 * @member {Number} totalUsdt
 */
StatisticsSummaryWalletData.prototype['totalUsdt'] = undefined;






export default StatisticsSummaryWalletData;

